const hiddenItems = document.querySelectorAll('.version-item.item-hide');
const toggleBtn = document.getElementById('toggleButton');
let expanded = false;

function toggleVersions() {
    expanded = !expanded;
    hiddenItems.forEach(item => {
        item.style.display = expanded ? 'flex' : 'none';
    });
    toggleBtn.innerHTML = expanded ? '▲ View less' : '▼ View more';
}